import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import NavBar from "@/components/NavBar.vue";
import OpenContainer from "@/components/OpenContainer.vue";
import PageFooter from "./components/PageFooter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

// Hide nav/footer/hero on /menu/* sub-pages.
const showDecorations = computed(() => !route.path.startsWith("/menu/"));

function onResize() {
  const root = document.documentElement;
  root.style.setProperty("--window-width", window.innerWidth + "px");
  root.style.setProperty("--window-height", window.innerHeight + "px");
}

onMounted(() => window.addEventListener("resize", onResize));
onUnmounted(() => window.removeEventListener("resize", onResize));

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showDecorations.value)
      ? (_openBlock(), _createBlock(NavBar, { key: 0 }))
      : _createCommentVNode("", true),
    (showDecorations.value)
      ? (_openBlock(), _createBlock(OpenContainer, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (showDecorations.value)
      ? (_openBlock(), _createBlock(PageFooter, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})